// import state from './state'
import DOMPurify from 'dompurify'

// Get data from the store / apply simple functions to calculate stuff from the state

const getters = {
    referentialLoaded: state => {
        if(state.referentialData == "") {
            return false
        }
        return true
    },
    filterActiveReferential: state => {
        return state.referentialData.filter(item => item.referentiel_id === state.selectedReferential)
    },
    fetchReferential: (state) => (id) => {
        return state.referentialData.find(item => item.referentiel_id === id)
    },
    getReferentialStatus: (state, getters, rootState) => (id) => {  // note: getters is not used here, but it is a common pattern in Vuex that rootstate is the third parameter
    ////console.log("mapstate", rootState.auth)
    let returnValue = {"LOCKED": false, "OWNER": false, "READONLY": false, "EDITOR":false, "FORCED":false}
    if (id === null || id === undefined) return returnValue;
    const referential = state.referentialData.find(item => item.referentiel_id === id)
    //if(referential == referential)return returnValue;
    if (!referential) return returnValue;
    ////console.log("referential status :",referential);
        const roles = referential.roles ? referential.roles: []
        ////console.log("roles ", roles)
        const lockedUntil = new Date(referential.locked_until)
        const now = new Date()
        if(rootState.auth.userInfo === undefined || rootState.auth.userInfo === null) {
            return returnValue
        }
        
        // If I'm the owner, set it to true. should be before the editor check? but it's not owner in this case, it's last modifier...
        // Only means if I'm the one who modified it last, not if I created it
        if(referential.modified_by === rootState.auth.userInfo.id) {
            ////console.log("It's now OWNER ?");
            returnValue.OWNER = true; // If the current user is the one who modified it, they can edit
        }

       /*  if(referential.modified_by === rootState.auth.userInfo.id && referential.status == "RELEASEUSED") {
            returnValue.FORCED = true
            returnValue.OWNER = true; // If the current user is the one who modified it, they can edit
        } */


        //TODO if I'm not RC... weird, owner is always false here, why check?
        // edit referential = EDITOR... right?
        // can access IF I'm admin / RC but not RE only
        if(lockedUntil < now && (returnValue.OWNER || roles.includes('RC')) && referential.status != 'RELEASEUSED'){
            ////console.log("lockedUntil < now && (returnValue.OWNER || roles.includes('RC')), lockedUntil :", lockedUntil, "\nnow :", now)
            returnValue.EDITOR = true
        }
        ////console.log("So far so good, am I even here?", referential)
        // If I'm only RE, set it to readonly not working it seems?
        if(roles && roles.includes('RE') && !roles.includes('RC')){
            ////console.log("It's now readonly ?");
            returnValue.READONLY = true
        } else if(referential.status === "EDITING") {
            ////console.log("It's now Not readonly (status==editing");
            returnValue.READONLY = false
        } else if(referential.status === "RELEASE") {
            ////console.log("It's now referential in production")
            // //console.log("state referential stuff thing", state.projectStatusByReferential[id])
            // There is double, because we still need to check if it's in use with projects
            /* if(state.projectStatusByReferential && state.projectStatusByReferential[id]) {
                // //console.log("project status by referential", state.projectStatusByReferential[id])
                if(state.projectStatusByReferential[id].some(project => project.status === "VALIDATED" || project.status === "ARCHIVED")) {
                    returnValue.READONLY = true
                } else {
                    returnValue.READONLY = false
                }
            } */
            ////console.log("It's now Not readonly (status==editing");
            returnValue.READONLY = false
            // returnValue.READONLY = true
        }else if(referential.status === "RELEASEUSED" || (roles.includes('RE') && referential.status === "ARCHIVE")){
            ////console.log("It's now readonly (status=RELEASEUSED?");
            returnValue.READONLY = true
            returnValue.FORCED = true
        } else if(referential.status === "ARCHIVE") {
            ////console.log("It's now readonly (status=archived?");
            returnValue.READONLY = true
        }
        // so... what if I edited? is it overwritten by owner afterwards?
        // ok, so it only shows if it's locked. not if it's readonly
        // If locked until is in the future, it's locked, even if I'm the one who locked it
        if (lockedUntil > now) {
            returnValue.LOCKED = true
            ////console.log("this id : " + id + " is supposed to be locked !", returnValue.LOCKED)
        }
        ////console.log("<locked> for id:" + id + "\nreturnValue result ?????",returnValue);
        return returnValue
    },

    // isReferentialLocked: (state, getters, rootState) => (id) => {
    isReferentialLocked: (state, getters) => (id) => {
        // const id = state.selectedReferential;
        const status = getters.getReferentialStatus(id)
        /* //console.log("isReferentialLocked => status information :", status) */
        if(status.FORCED){
            ////console.log("isReferentialLocked => FORCED ")
            return true
        }else{
            if(status.READONLY) {
                ////console.log("isReferentialLocked => READONLY ")
                return true
            }
            if(!status.LOCKED) {
                ////console.log(id + "id <= isReferentialLocked => !LOCKED")
                return false // If not locked, always editable
            }
        }

        /* if(status.EDITOR){
            return false
        } */
        // //console.log("showd return for id", id, "status", !(status.OWNER && status.LOCKED))
        return !(status.OWNER && status.LOCKED) // If locked, must be owner to edit

        // if (id === null || id === undefined) return false;
      
        // const referential = state.referentialData.find(item => item.referentiel_id === id)
        // if (!referential) return false;
      
        // const lockedUntil = new Date(referential.locked_until)
        // const now = new Date();
      
        // let statusLock = true
        // if(referential.status === "EDITING") {
        //     statusLock = false
        // } else if(referential.status === "PRODUCTION") {
        //     statusLock = false
        //     //console.log("statuslock for referential", referential.referentiel_id, referential.status, statusLock)
        // } else if(referential.status === "ARCHIVED") {
        //     statusLock = true
        // }

        // return (
        //   (lockedUntil > now) || statusLock
        // )
    },
    lockedClass:(state, getters) => (id) => {
        const status = getters.getReferentialStatus(id || state.selectedReferential);
        /* const archived = referential?.status == 'ARCHIVE';
        const notRE = !referential?.RE; */
        /* //console.log("lockedClass status:",status, "\nreferential.RE:", referential?.RE, "\nreferential.status :",referential?.status) */
        ////console.log("!READONLY =" + (!status.READONLY) + "\n!status.OWNER && status.LOCKED =" + !status.OWNER + "" + status.LOCKED/*  || status.READONLY */ + "\n!status.FORCED =" + !status.FORCED + "\nlockedClass : = ",!status.RE && (!status.OWNER && status.LOCKED || status.READONLY) && !status.FORCED)

        return (
        !status.READONLY && (!status.OWNER && 
        status.LOCKED) &&  
        !status.FORCED
        );
    },
    formatDate: () => (dateString) => {

        if (!dateString) return 'Non définie'
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',    
            minute: '2-digit'
        });
    },
    formatNumberWithSeparator: (state) => (value, tag) => { 
    if (value === null || value === undefined || value === '') return '';
    
        const dbItem = state.referentialDatabase.find(item => item.tag === tag);
        const maxDigits = (dbItem && dbItem.digits !== undefined) ? dbItem.digits : 2;
        //console.log("maxDigits: ",maxDigits,"\nvalue :", value, "\ntag :", tag, "result : ", Number(value.toLocaleString('de-CH', {maximumFractionDigits : maxDigits})))
        return Number(value).toLocaleString('de-CH', {
            maximumFractionDigits: maxDigits
            });
    },
    nowDate: () => {   
        return new Date()
    },
    fetchCriteria: (state) => (id) => {
        return state.criteriaTree.find(item => item.id === id)
    },
    fetchRootCriteria: (state) => (id) => {
        let referential = state.referentialData.find(item => item.referentiel_id === id)
        if (!referential) return null; // Prevents errors if referential is not found
        return state.criteriaTree.find(item => item.id === referential.root_criteria)
    },
   
    fetchRootCriteria2: (state) => (id) => {    // supposed to be adapted, but this does not change, so I'm keeping it
        const referential = state.referentialData.find(item => item.referentiel_id === id);
        if (!referential) return []; // Prevents errors if referential is not found
    
        const rootCriteria = state.criteriaTree.find(item => item.id === referential.root_criteria);
        return rootCriteria ? [rootCriteria] : []; // Ensures Vue always gets an array
    },
    
    fetchChildrenCriteria: (state) => (ids) => {
        return [...state.criteriaTree.filter(item => ids.includes(item.id)).sort((a, b) => a.order_number - b.order_number)]
    },
    fetchQuestionCriteria: (state) => (id) => {
        return state.questionTree
            .find(item => id === item.criteria_id)
    },
    fetchQuestion: (state) => (id) => {
        return state.questionTree
            .find(item => id === item.id)
    },
    getMaxLength: (state) => (field) => {
        const entry = state.maxLength.find(obj => Object.hasOwn(obj, field));
        return entry ? entry[field] : 255
    },
    truncateText: () => (text, maxLength) => {
        if (!text) return ''
        return text.length > maxLength ? text.substring(0, maxLength) + '…' : text;
    },
    usersWithAccess: (state) =>  {
        const rolesMap = {}

        // Build a map of user_id -> { RO: boolean, RE: boolean }
        state.userListRightsReferential.forEach(entry => {
            if (!rolesMap[entry.user_id]) {
                rolesMap[entry.user_id] = { RC: false, RE: false }
            }
            if (typeof entry.roles === "string") {
                const rolesArray = entry.roles.split(",").map(role => role.trim())
                //console.log("rolesArray", rolesArray, "\nstate.userListRightsReferential : ", state.userListRightsReferential)
                if (rolesArray.includes("RC")) {
                    rolesMap[entry.user_id].RC = true
                }
                if (rolesArray.includes("RE")) {
                    rolesMap[entry.user_id].RE = true
                }
            }
        });
        return state.userList
            .filter(user => user.adminRole === 1 || rolesMap[user.user_id]) // Include admins and users with RO or RE
            .map(user => ({
                user_id: user.user_id,
                name: user.name,
                surname: user.surname,
                username: user.username,
                email: user.email,
                admin: user.adminRole,
                RC: user.adminRole === 1 ? true : (rolesMap[user.user_id]?.RC || false),
                RE: user.adminRole === 1 ? true : (rolesMap[user.user_id]?.RE || false)
            }))
            .sort((a, b) => {
                if(a.admin < b.admin) return 1
                if(a.name < b.name) return -1
                if(a.name > b.name) return 1
                if(a.surname < b.surname) return -1
                if(a.surname > b.surname) return 1
                return 0
            });
    },
    usersWithoutAccess: (state) => {
        // Build a Set of user_ids that have any rights
        const usersWithRights = new Set(state.userListRightsReferential.map(entry => entry.user_id));

        // Return users who are NOT in usersWithRights
        return state.userList
            .filter(user => user.adminRole !== 1 && !usersWithRights.has(user.user_id))
            .map(user => ({
                user_id: user.user_id,
                name: user.name,
                surname: user.surname,
                username: user.username,
                email: user.email,
                admin: user.adminRole,
                RC: false,
                RE: false
            }))
            .sort((a, b) => {
                if(a.admin < b.admin) return 1;
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                if(a.surname < b.surname) return -1;
                if(a.surname > b.surname) return 1;
                return 0;
            })
    },
    adminUsers: (state) => {
        return state.userList
            .filter(user => user.adminRole === 1)
            .map(user => ({
                user_id: user.user_id,
                name: user.name,
                surname: user.surname,
                email: user.email,
                username: user.username,
                admin: user.adminRole
            }))
            .sort((a, b) => {
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                if(a.surname < b.surname) return -1;
                if(a.surname > b.surname) return 1;
                return 0;
            })
    },
    nonAdminUsers: (state) => {
        return state.userList
            .filter(user => user.adminRole !== 1)
            .map(user => ({
                user_id: user.user_id,
                name: user.name,
                surname: user.surname,
                username: user.username,
                email: user.email,
                admin: user.adminRole
            }))
            .sort((a, b) => {
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                if(a.surname < b.surname) return -1;
                if(a.surname > b.surname) return 1;
                return 0;
            })
    },
    referentialDatabaseOrdered: (state) => {
        // return Array.isArray(state.referentialDatabase) ? state.referentialDatabase : []
        return state.referentialData
            .sort((a, b) => {
                if (a.locationChapter < b.locationChapter) return -1;
                if (a.locationChapter > b.locationChapter) return 1;
                if (a.view_order < b.view_order) return -1;
                if (a.view_order > b.view_order) return 1;
                return 0;
            })
    },
    getDatabaseChapters: (state) => {
        const chapters = new Set();
        state.referentialDatabase.forEach(item => {
            if (item.chapter) {
                chapters.add(item.locationChapter);
            }
        })
        return Array.from(chapters).sort();
    },
    getDatabaseForChapter: (state) => (chapter) => {
        return state.referentialDatabase
            .filter(item => item.locationChapter === chapter)
            .sort((a, b) => a.view_order - b.view_order);
    },
    getGroupedDatabase: (state) => {
        const chapterGroups = {}

        state.referentialDatabase.forEach(item => {
        // if (item.count === 0) return
            const chapter = item.locationChapter
            if (!chapterGroups[chapter]) {
                chapterGroups[chapter] = {
                symbols: [],
                rows: {}, // key = title, value = { title, valuesBySymbol }
                singles: {},
                }
            }
            if(item.count !== 0) {
                chapterGroups[chapter].symbols.push({
                    tag: item.tag,
                    symbol: item.symbol,
                    unit: item.unit,
                    description: item.description,
                })
            }
            item.titles.forEach((title, i) => {
                if (!chapterGroups[chapter].rows[title]) {
                    chapterGroups[chapter].rows[title] = { title, values: {} }
                }
                chapterGroups[chapter].rows[title].values[item.tag] = item.values[i]
                chapterGroups[chapter].rows[title].index = i
                // //console.log("Item for i", i, item)
                // chapterGroups[chapter].rows[title].valuesBySymbol = item.valuesBySymbol[i]
            })
            if(item.count === 0) {
                ////console.log("Item is a single", item)
                chapterGroups[chapter].singles[item.tag] = {
                    tag: item.tag,
                    symbol: item.symbol,
                    unit: item.unit,
                    description: item.description,
                    value: item.value
                }
            }
        })
        Object.values(chapterGroups).forEach(chapter => {
        chapter.symbols.sort((a, b) => a.view_order - b.view_order)
    });
    ////console.log("chapterGroups", chapterGroups)
    return chapterGroups
  },
  getProjectsAfterValidation: (state) => {
      let count = 0
      if(state.selectedReferential === 0) {
          return 0
        }
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return 0
            numberProjects.forEach(project => {
        if(project.status == "EDITING" || project.status == "") {
            //console.log("Project ", project.project_id, " is in edition")
        } else if(project.status == "VALIDATION") {
            //console.log("Project ", project.project_id, " is in validation")
        } else {
            //console.log("Project ", project.project_id, " is nowhere to be seen: ", project.status)
            count++
        }
    })
    return count
  },
  getProjectsAfterValidationList: (state) => {
/* if (!state.projectStatusByReferential) {
        return {};
    }
    const entries = Object.entries(state.projectStatusByReferential)
        .map(([referentialId, projects]) => {
            const filteredProjects = (projects || []).filter(p => p.status === "VALIDATED" || p.status === "ARCHIVED");
            return [referentialId, filteredProjects];
        });
    return Object.fromEntries(entries); */

    const result = {}
    //console.log("state.projectStatusByReferentialFin : ", state.projectStatusByReferential)
    if (state.projectStatusByReferential) {
        Object.keys(state.projectStatusByReferential).forEach(referentialId => {
            result[referentialId] = (state.projectStatusByReferential[referentialId] || [])
            .filter(project => project.status === "VALIDATED" || project.status === "ARCHIVE")
        })
    }
    return result;
    // return numberProjects.filter(project => project.status === "VALIDATED" || project.status === "ARCHIVED");
  },
    /* getProjectsInValidation: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return 0
        //console.log("numberProjectsVALIDATION.length :",numberProjects.filter(project => project.status === "VALIDATION").length)
        return numberProjects.filter(project => project.status === "VALIDATION").length;
    },
    getProjectsValidated: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsVALIDATED.length :",numberProjects.filter(project => project.status === "VALIDATED").length)
        return numberProjects.filter(project => project.status === "VALIDATED").length;
    },
    getProjectsBackInEdition : (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsEDITING.length :",numberProjects.filter(project => project.status === "EDITING").length)
        return numberProjects.filter(project => project.status === "EDITING").length;
    },
    getProjectsInArchived: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsARCHIVE.length :",numberProjects.filter(project => project.status === "ARCHIVE").length)
        return numberProjects.filter(project => project.status === "ARCHIVE").length;
    }, */
    getProjectsInValidationList: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsValidation :",numberProjects.filter(project => project.status === "VALIDATION"))
        return numberProjects.filter(project => project.status === "VALIDATION");
    },
    getProjectsValidatedList: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsValidated :",numberProjects.filter(project => project.status === "VALIDATED"))
        return numberProjects.filter(project => project.status === "VALIDATED");
    },
    getProjectsInArchivedList: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsArchived :",numberProjects.filter(project => project.status === "ARCHIVE"))
        return numberProjects.filter(project => project.status === "ARCHIVE" && project.has_evaluator===true);
    },
    getProjectsBackInEditionList : (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : []
        if(!numberProjects) return []
        //console.log("numberProjectsEdition :",numberProjects.filter(project => project.status === "EDITING"))
        return numberProjects.filter(project => project.status === "EDITING" && project.has_evaluator===true);
    },
    //WHAT IS THE POINT OF THIS ???
    /* getProjectsInPastValidationList: (state) => {
        const numberProjects = state.projectStatusByReferential ? state.projectStatusByReferential[state.selectedReferential] : [];
        //console.log("numberProjects please : ",numberProjects)
        if (!numberProjects) {
            return [];
        }
        return numberProjects.filter(project => project.status !== "VALIDATION" && project.status !== "EDITING");
    }, */
    getUsersWithAccessProject: (state) => {
        const rolesMap = {}

        // Build a map of user_id -> { RO: boolean, RE: boolean }
            state.userListRightsProject.forEach(entry => {
            if (!rolesMap[entry.user_id]) {
                rolesMap[entry.user_id] = { PC: false, PE: false }
            }
            //console.log("entry to follow :",entry)
            if (typeof entry.roles === "string") {
                //console.log()
                const rolesArray = entry.roles.split(",").map(role => role.trim())
                /* if (rolesArray.includes("PC")) {
                    rolesMap[entry.user_id].PC = true
                } */
                if (rolesArray.includes("PE")) {
                    rolesMap[entry.user_id].PE = true
                }
            }
        });
        return state.userList
            .filter(
            user => rolesMap[user.user_id] && 
            rolesMap[user.user_id].PE // Only include users with PE role
            )
            .map(user => ({
                user_id: user.user_id,
                name: user.name,
                surname: user.surname,
                username: user.username,
                email: user.email,
                PC: (rolesMap[user.user_id]?.PC || false),
                PE: (rolesMap[user.user_id]?.PE || false)
            }))
            .sort((a, b) => {
                if(a.name < b.name) return -1
                if(a.name > b.name) return 1
                if(a.surname < b.surname) return -1
                if(a.surname > b.surname) return 1
                return 0
            });
    },
    usersWithoutProjectAccess: (state) => {
    const rolesMap = {};
    state.userListRightsProject.forEach(entry => {
        if (!rolesMap[entry.user_id]) {
            rolesMap[entry.user_id] = { PC: false, PE: false }
        }
        if (typeof entry.roles === "string") {
            const rolesArray = entry.roles.split(",").map(role => role.trim())
            /* if (rolesArray.includes("PC")) {
                rolesMap[entry.user_id].PC = true
            } */
            if (rolesArray.includes("PE")) {
                rolesMap[entry.user_id].PE = true
            }
        }
        //console.log("userListRightsProjectentryW/o :", entry)
    });
    //console.log("rolesMap", rolesMap)
    // Build a set of user_ids who have PE of any type, combined or not
    const usersWithPEOnly = new Set(
        Object.entries(rolesMap)
        .filter(([, roles]) => roles.PE)
        .map(([user_id]) => user_id)
    )
    //console.log("usersWithPEOnly", usersWithPEOnly)
    return state.userList
        .filter(user => !usersWithPEOnly.has(String(user.user_id)))
        .map(user => ({
            user_id: user.user_id,
            name: user.name,
            surname: user.surname,
            username: user.username,
            email: user.email,
            PC: rolesMap[user.user_id]?.PC || false,
            PE: false
        }))
        .sort((a, b) => {
            if(a.name < b.name) return -1
            if(a.name > b.name) return 1
            if(a.surname < b.surname) return -1
            if(a.surname > b.surname) return 1
            return 0
        })
    },
    sanitizeText:() => (text) => {
        if(!text)return;
        return DOMPurify.sanitize(text);
    }
}

export default getters